import React, { useState, useContext, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import {
  Icon, Menu, Segment, Sidebar, Header, Button,
  Popup, Modal, Dimmer, Grid, Loader, Form, Dropdown, DropdownItemProps
} from "semantic-ui-react";
import { ReactSVG } from "react-svg";
import { useCookies } from "react-cookie";
import { CaseDatagridViewModel, IdNameCountViewModel, IdNameViewModel } from '../../types/ServerDTO';
import DataGrid, { Column } from '../Common/SharedComponents/DataGrid';
import DataGridFilters from '../Common/SharedComponents/DataGridFilters';
import { Aggregation, DynamicSearchResponse, FilterData } from '../../types/filterDataGridDTO';
import listBox from "../../assets/images/list-boxes.svg";
import collapseAll from "../../assets/images/collapse-all.svg";
import listCheckedIco from "../../assets/images/list-checked.svg";
import DocumentAdd from "../../assets/images/document-add.svg";
import onCompletedIcons from "../../assets/images/Status-completed-Icon.svg";
import onClosedIcons from "../../assets/images/Status-closed-Icon.svg";
import onNewFileIcons from "../../assets/images/Status-New-Icon.svg";
import onProgressIcons from "../../assets/images/Status-inprogress-Icon.svg";
import onAwaitingInfo from "../../assets/images/Status-Awaiting-info-Icon.svg";
import AppContext from '../../AppContext';
import axiosInstance from '../../helpers/axiosInstance';
import UserInfo from '../Common/SharedComponents/UserInfo';
import SwitchTheme from '../Common/SharedComponents/SwitchTheme';

const DashboardPage: React.FC = () => {
  const [cookies, setCookies] = useCookies(['show_cases_left_nav']);
  const [searchParams] = useSearchParams();
  const queryUnreadValue = searchParams.get('unread');
  const querySearchFiltersValue = searchParams.get('SearchFilters');
  const queryTypeValue = searchParams.get('type');
  const tmpCaseDataGridTypeId = queryTypeValue !== null ? queryTypeValue : localStorage.getItem('caseDataGridTypeId');
  const caseDataGridTypeId = querySearchFiltersValue ? 3 : ((tmpCaseDataGridTypeId) ? parseInt(tmpCaseDataGridTypeId) : 1);

  const navigate = useNavigate();
  const { userInfo, themeVersion } = useContext(AppContext);
  const [additionalAggregations, setAdditionalAggregations] = useState<{ [key: string]: any } | null>({ 'caseDataGridTypeId': caseDataGridTypeId });
  const [visible, setVisible] = useState((cookies['show_cases_left_nav'] === undefined || cookies['show_cases_left_nav'] === 'true') ? true : false);

  const [responseDataModel, setResponseDataModel] = useState<DynamicSearchResponse<CaseDatagridViewModel> | null>(null);
  const [Aggregates, setAggregates] = useState<Aggregation[] | null>(null);
  const [filters, setFilters] = useState<Record<string, FilterData> | null>(null);

  const [reloadDataCount, setReloadDataCount] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [assignedUsers, setAssignedUsers] = useState<any>([]);
  const [assignedToId, setAssignedToId] = useState<number | null>(0);
  const [caseRecordId, setCaseRecordId] = useState<number>(0);

  let columns: Column<CaseDatagridViewModel>[] = [
    {
      field: 'isHighPriority', header: "", sortable: true, headerStyle: { textAlign: 'center', width: '5%' }, style: { textAlign: 'left', width: '5%' }, accessor: (row: CaseDatagridViewModel) => row.isHighPriority ? <Icon name='exclamation' color='red' size='large' onClick={() => {
        setIsLoading(true);
        handlePriority(row.caseNumber);
      }} style={{ cursor: 'pointer' }} /> : <button className="priority-button" onClick={() => {
        setIsLoading(true);
        handlePriority(row.caseNumber);
      }}>
        <span className="text">&nbsp;</span>
        <span className="icon">&#x2757;</span>
      </button>
    },
    {
      field: 'subject', header: 'Subject', sortable: true, className: "wrap-text", headerStyle: { textAlign: 'left', width: '35%' }, style: { textAlign: 'left', width: '35%' }, accessor: (row: CaseDatagridViewModel) => <div style={{ minWidth: 250, wordWrap: 'break-word' }} className={row.hasUnreadEmails ? 'row-strong' : ''}>
        <a href={`/case/${row.caseNumber}`}>{row.subject}</a>
      </div>
    },
    { field: 'office', header: 'Office', sortable: true, className: "wrap-text", headerStyle: { width: '10%' }, style: { width: '10%' }, accessor: (row: CaseDatagridViewModel) => row.office },
    { field: 'constituent', header: 'Constituent', sortable: true, className: "wrap-text", headerStyle: { width: '10%' }, style: { width: '10%' }, accessor: (row: CaseDatagridViewModel) => row.constituent },
    { field: 'createdDate', header: 'Created', sortable: true, className: "wrap-text", headerStyle: { width: '10%' }, style: { width: '10%' }, accessor: (row: CaseDatagridViewModel) => row.createdDate },
    { field: 'messageDate', header: 'Last Message', sortable: true, className: "wrap-text", headerStyle: { width: '10%' }, style: { width: '10%' }, accessor: (row: CaseDatagridViewModel) => row.messageDate },
    {
      field: 'assignedTo', header: 'Assigned to', sortable: true, className: "wrap-text", headerStyle: { width: '10%' }, style: { width: '10%' }, accessor: (row: CaseDatagridViewModel) => <a onClick={() => {
        setIsModalOpen(true);
        setIsLoading(true);
        fetchUsers(row.caseId, row.assignedTo);
      }}>{row.assignedToName ? row.assignedToName : 'Unassigned'}</a>
    },
    { field: 'caseNumber', header: 'Case#', sortable: true, headerStyle: { width: '5%' }, style: { width: '5%' }, accessor: (row: CaseDatagridViewModel) => row.caseNumber ? row.caseNumber : '' },
    {
      field: 'status', header: 'Status', sortable: true, headerStyle: { width: '5%' }, style: { width: '5%' }, accessor: (row: CaseDatagridViewModel) => {
        switch (row.status) {
          case 'New': {
            return <Popup content={row.status} trigger={<span className="btn-round"><ReactSVG src={onNewFileIcons} /></span>} />
          }
          case 'In-progress': {
            return <Popup content={row.status} trigger={<span className="btn-round"><ReactSVG src={onProgressIcons} /></span>} />
          }
          case 'Awaiting Info': {
            return <Popup content={row.status} trigger={<span className="btn-round"><ReactSVG src={onAwaitingInfo} /></span>} />
          }
          case 'Completed': {
            return <Popup content={row.status} trigger={<span className="btn-round"><ReactSVG src={onCompletedIcons} /></span>} />
          }
          case 'Closed': {
            return <Popup content={row.status} trigger={<span className="btn-round"><ReactSVG src={onClosedIcons} /></span>} />
          }
          default: {
            return null;
          }
        }
      },
    },
  ];

  if (userInfo?.IsAllOffices !== "True") {
    columns.splice(2, 1);
  }

  useEffect(() => {
    document.title = 'Cases - Adjure';
  }, []);

  const closeModal = () => {
    setIsModalOpen(false);
    setAssignedUsers([]);
    setAssignedToId(0);
  }

  const fetchUsers = async (caseId: number, assignedTo: any) => {
    axiosInstance.get(`/Case/GetUsersByCase/${caseId}`).then(({ data, status }) => {
      if (status === 200) {
        setCaseRecordId(caseId);
        // const assignedToIndex = _.findIndex(data, { id: assignedTo });
        // data.splice(assignedToIndex, 1);
        // setAssignedToId(assignedTo);
        setAssignedUsers(data);
        setIsLoading(false);
      }
    })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  }

  const handleAssignedTo = async () => {
    setIsLoading(true);
    axiosInstance.post(`/Case/AssignCase/${caseRecordId}/${assignedToId}`, {}).then(({ data, status }) => {
      if (status === 200) {
        closeModal();
        setIsLoading(false);
        setReloadDataCount(reloadDataCount + 1);
      }
    })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  }

  const handlePriority = async (caseNumber: number) => {
    setIsLoading(true);
    axiosInstance.post(`/dashboard/UpdateCasePriorty/${caseNumber}`, {}).then(({ data, status }) => {
      if (status === 200) {
        setIsLoading(false);
        setReloadDataCount(reloadDataCount + 1);
      }
    })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  }

  const convertToDropDownProps = (MasterItems: Array<IdNameViewModel>) => {
    return (MasterItems || []).map((item: IdNameViewModel) => ({
      key: item.id,
      text: item.name,
      value: item?.id,
    } as DropdownItemProps));
  }

  const handleDropdownChange = (event: React.SyntheticEvent<HTMLElement>, data: any) => {
    setAssignedToId(data.value);
  };

  const handleAdditionalAggregationsClick = (evn: any, name: string) => {
    if (responseDataModel && responseDataModel?.master && responseDataModel.master.searchTypeMapper) {
      const propertyName = responseDataModel.master.searchTypeMapper[name];
      const id = evn.target.dataset.id || 0;
      setAdditionalAggregations((prev) => {
        return { ...prev, [propertyName]: parseInt(id) }
      });
    }
  };

  const handleAdditionalAggregationsActive = (id: any, name: string) => {
    if (responseDataModel && responseDataModel?.master && responseDataModel.master.searchTypeMapper && additionalAggregations) {
      const prpertyName = responseDataModel.master.searchTypeMapper[name];
      return additionalAggregations[prpertyName] === id;
    }
    return false;
  };

  const handleShowFilters = (event: any) => {
    setVisible(!visible);
  };

  const activeItemIcons = (caseDataGridType: string | null) => {
    if (!caseDataGridType) return null;
    switch (caseDataGridType) {
      case "All Cases": return <ReactSVG src={listBox} />;
      case "My Open Cases": return <ReactSVG src={collapseAll} />;
      case "Open Cases": return <ReactSVG src={listCheckedIco} />;
      default: return <ReactSVG src={listBox} />
    };
  }

  const convertBase64ToJSON = (base64String: string | null): Record<string, FilterData> | null => {
    try {
      if (base64String === null) {
        return null;
      }

      // Decode Base64 string
      const decodedString = decodeURIComponent(window.atob(base64String));

      // Parse JSON string as object
      const decodedJSON = JSON.parse(decodedString, (key, value) => {
        if (typeof value === 'string') {
          return decodeURIComponent(value);
        }
        return value;
      }) as Record<string, FilterData>;

      return decodedJSON;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const buttonToggleClass = visible ? "btn-toggle btn-toggle--is-active" : "btn-toggle";

  let defaultExpand: any;
  const defaultFilter = convertBase64ToJSON(querySearchFiltersValue);
  defaultExpand = defaultFilter ? Object.keys(defaultFilter).reduce((result, key) => {
    const capitalizedKey = key.charAt(0).toUpperCase() + key.slice(1);
    return { ...result, [capitalizedKey]: true };
  }, {}) : undefined;
  const dashboardFilter = localStorage.getItem('dashboardFilter');
  if (dashboardFilter !== null) {
    const parsedFilters = JSON.parse(dashboardFilter) as Record<string, FilterData>;
    defaultExpand = {};
    for (let key in parsedFilters) {
      if (parsedFilters[key] && parsedFilters[key].ids && parsedFilters[key].ids.length > 0) {
        let formattedKey = key.charAt(0).toUpperCase() + key.slice(1);
        defaultExpand[formattedKey] = true;
      }
    }
  } else if (queryUnreadValue !== null) {
    defaultExpand = {
      Unread: true
    };
  }

  let caseTitle = '';
  if (caseDataGridTypeId === 1) {
    caseTitle = 'My Open Cases';
  } else if (caseDataGridTypeId === 2) {
    caseTitle = 'Open Cases';
  } else if (caseDataGridTypeId === 3) {
    caseTitle = 'All Cases';
  }

  return (
    <div>
      <section className="section">
        <Sidebar.Pushable as={Segment}>
          <Sidebar
            animation="push"
            icon="labeled"
            inverted
            vertical
            width="thin"
            visible={visible}
          >
            <div className="sidebar__inner">
              <div className={visible ? 'display-pin' : 'hide-pin'}>
                {(cookies['show_cases_left_nav'] === undefined || cookies['show_cases_left_nav'] === 'true') && (
                  <Icon name='pin' onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                    setCookies('show_cases_left_nav', 'false', { path: '/' });
                  }} />
                )}
                {cookies['show_cases_left_nav'] === 'false' && (
                  <Icon name='pin' rotated='clockwise' onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                    setCookies('show_cases_left_nav', 'true', { path: '/' });
                  }} />
                )}
              </div>
              <nav className="nav-sidebar">
                {
                  responseDataModel && responseDataModel?.searchResults && responseDataModel?.searchResults?.additionalAggregations &&
                  <>
                    {
                      (responseDataModel?.searchResults?.additionalAggregations || []).map((additionalAggregation: any, index: number) => {
                        return <React.Fragment key={additionalAggregation?.name || index}>
                          {
                            additionalAggregation?.aggregates && additionalAggregation?.aggregates.length > 0 &&
                            <Menu compact icon="labeled" vertical>
                              {
                                (additionalAggregation?.aggregates || []).map((aggregate: IdNameCountViewModel) => {
                                  return (<Menu.Item
                                    key={aggregate.id}
                                    data-name={aggregate.name}
                                    data-id={aggregate.id}
                                    active={handleAdditionalAggregationsActive(aggregate.id, additionalAggregation.name)}
                                    onClick={(evn) => {
                                      localStorage.setItem('isAdditionalAggregationsClicked', '1');
                                      localStorage.setItem('caseDataGridTypeId', aggregate.id.toString());
                                      handleAdditionalAggregationsClick(evn, additionalAggregation.name);
                                    }}
                                  >
                                    {
                                      additionalAggregation.name === 'CaseDataGridType' ?
                                        <>
                                          <div className="nav__ico">
                                            {activeItemIcons(aggregate.name)}
                                          </div>
                                          {aggregate.name} ({aggregate.count})
                                        </>
                                        : <>{aggregate.name} ({aggregate.count})</>
                                    }
                                  </Menu.Item>)
                                })
                              }
                            </Menu>
                          }
                        </React.Fragment>
                      })
                    }
                  </>
                }
              </nav>
              {
                Aggregates && Aggregates.length > 0 &&
                <div className="filters">
                  <Header as="h2">
                    Filter by
                    <span style={{ float: 'right', fontSize: '1.4rem', cursor: 'pointer', color: '#2d76d5' }} onClick={() => { localStorage.removeItem('dashboardFilter'); window.location.href = '/dashboard'; }}>Reset</span>
                  </Header>
                  <div className="select-holder">
                    {
                      filters &&
                      <DataGridFilters<CaseDatagridViewModel>
                        aggregations={Aggregates || []}
                        setFilters={setFilters}
                        filters={filters}
                        responseDataModel={responseDataModel}
                        setResponseDataModel={setResponseDataModel}
                        key={'DataGridWithFilters'}
                        defaultFilterExpanded={defaultExpand}
                      />
                    }
                  </div>
                </div>
              }
            </div>
          </Sidebar>
          <Sidebar.Pusher>
            <div className="section__head">
              <div className="section__head-content">
                <Header as="h1">{caseTitle}</Header>
              </div>
              <div className="section__actions">
                <UserInfo />
                {userInfo?.IsAllOffices !== "True" && (
                  <Button color="violet" onClick={() => navigate('/case')}>
                    <Button.Content visible style={{ whiteSpace: 'nowrap' }}>
                      Create Case
                    </Button.Content>
                    <Button.Content visible>
                      <ReactSVG src={DocumentAdd} />
                    </Button.Content>
                  </Button>
                )}
                <SwitchTheme />
              </div>
              <Button
                basic
                className="btn-filter"
                onClick={(event: any) =>
                  handleShowFilters(event)
                }
              >
                {visible ? <span> Close Filters</span> : <span>Open Filters</span>}
              </Button>
            </div>
            <div className="section__body">
              <Modal
                onClose={closeModal}
                open={isModalOpen}
                className={themeVersion === 'black' ? 'dark-theme' : ''}
                style={{ width: 300 }}
              >
                <Modal.Header style={{ minHeight: '4rem' }}>
                  <span><Icon name="close" style={{ float: "right", cursor: "pointer" }} onClick={closeModal} /></span>
                </Modal.Header>
                <Modal.Content>
                  <Dimmer.Dimmable as="div" dimmed={isLoading}>
                    <Dimmer active={isLoading} inverted={true}>
                      <Loader>Loading</Loader>
                    </Dimmer>
                    <Grid padded>
                      <Grid.Row>
                        <Grid.Column>
                          <Form.Field>
                            <div className='field'>
                              <label style={{ color: '#000' }}>Assign to</label>
                              <Dropdown
                                name="assignedToId"
                                options={convertToDropDownProps(assignedUsers)}
                                fluid
                                selection
                                value={assignedToId ? assignedToId : 0}
                                onChange={handleDropdownChange}
                              />
                            </div>
                          </Form.Field>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Dimmer.Dimmable>
                </Modal.Content>
                <Modal.Actions>
                  <Grid>
                    <Grid.Column>
                      <Button type="submit" onClick={handleAssignedTo} className='violet right floated button' style={{ padding: '1.1rem 2.1rem', borderRadius: '0rem' }}>Confirm</Button>
                      <Button type="button" className='second right floated button' style={{ padding: '1.1rem 2.1rem', borderRadius: '0rem', color: 'white' }} onClick={closeModal}>Cancel</Button>
                    </Grid.Column>
                  </Grid>
                </Modal.Actions>
              </Modal>
              <DataGrid<CaseDatagridViewModel>
                apiUrl={`/Dashboard/CaseDatagrid`}
                downloadURL={`/Dashboard/DownloadCaseDatagrid`}
                initialViewModelURL={`/Dashboard/GetCaseDataGrid`}
                additionalAggregations={additionalAggregations || undefined}
                columns={columns}
                rowsPerPage={10}
                defaultSortByField={responseDataModel?.hasUnreadEmails ? 'messageDate' : 'caseNumber'}
                defaultSortOrderDesc={true}
                rowKey={(row: CaseDatagridViewModel) => row.caseId}
                noDataMessage={'No case(s) to display'}
                searchPlaceholder='Search by subject, constituent, or case number'
                filters={filters}
                setFilters={setFilters}
                setAggregates={setAggregates}
                responseDataModel={responseDataModel}
                setResponseDataModel={setResponseDataModel}
                defaultFilter={defaultFilter}
                reloadData={reloadDataCount}
              />
            </div>
          </Sidebar.Pusher>
        </Sidebar.Pushable>
        <button
          className={buttonToggleClass}
          onClick={(e: React.MouseEvent<HTMLButtonElement>) => setVisible(!visible)}
          style={{ backgroundColor: '#7152F6' }}
        ></button>
      </section>
    </div>
  );
}

export default DashboardPage;